var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrampoline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.9,59.9L63.6,38.6h39.3c0-5.7-4.6-10.3-10.3-10.3H30.9c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1H49l38.5,38.5 c3.5,3.5,9.2,3.5,12.7,0c1.8-1.8,2.6-4.1,2.6-6.4v-27h-18L84.9,59.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.6,
    cy: 83.5,
    rx: 9,
    ry: 9
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144,111.8l-59.1,12.6c-8.6,1.8-17.3,1.8-25.8,0L0,111.8v2.8l58.5,12.5c4.5,1,9,1.4,13.5,1.4c4.5,0,9-0.5,13.5-1.4 l58.5-12.6V111.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrampoline);
export default __webpack_public_path__ + "static/media/trampoline.ced8bdfdb3c6eba9c322a49e6c9aec0f.svg";
export { ForwardRef as ReactComponent };